import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';
import { qrCodeDialogComponent } from '@app/qr-code-dialog/qr-code-dialog.component';
import { Hostel, Room, Rooms } from '@app/services/api/api.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Subject } from 'rxjs';
import { RoomSkeletonComponent } from './room-skeleton/room-skeleton.component';
import { RoomComponent } from './room/room.component';

@Component({
  selector: 'app-room-list',
  standalone: true,
  imports: [
    CommonModule,
    RoomComponent,
    qrCodeDialogComponent,
    RoomSkeletonComponent,
    AngularSvgIconModule,
  ],
  templateUrl: './room-list.component.html',
  styleUrls: ['./room-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomListComponent {
  @Input()
  public hostel: Hostel;

  @Input()
  public rooms: Rooms;

  @Input()
  public isLoading: boolean;

  public showDialog = false;

  private destroyed = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  roomsEmpty() {
    const isEmpty = !this.rooms
      ? true
      : !this.rooms?.privateRooms?.length &&
          !this.rooms?.dormRooms?.length &&
          !this.rooms?.familyRooms?.length;

    return isEmpty;
  }

  ngOnInit() {
    this.cdr.markForCheck();
  }

  public open() {
    this.showDialog = true;
  }

  public close() {
    this.showDialog = false;
  }

  public trackById(i: number, r: Room) {
    return r._id;
  }


  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
